import vtexService from '../../services/vtex';

export default {
  state: {
    vtexSalesOrder: {},
  },

  mutations: {
    SET_VTEX_ORDER(state, salesOrder) {
      state.vtexSalesOrder = salesOrder;
    },
    CLEAR_VTEX_ORDER(state) {
      state.vtexSalesOrder = {};
    },
  },

  getters: {
    vtexSalesOrder: state => state.vtexSalesOrder,
  },

  actions: {
    getVtexOrder: ({ commit }, orderNumber) => {
      vtexService.getSalesOrder(orderNumber).then((response) => {
        commit('SET_VTEX_ORDER', response)
      })
    },
    clearVtexOrder: ({ commit }) => {
      commit('CLEAR_VTEX_ORDER')
    }
  },
};



// WEBPACK FOOTER //
// /src/store/modules/vtex.js